import { action } from 'easy-peasy';
import { ISetDeleteRequestsAction } from '../types';

const setDeleteRequests: ISetDeleteRequestsAction = action((state, payload) => {
  const { items, pagination } = payload;

  if (pagination) {
    state.pagination.pageNumber = pagination.pageNumber;
    state.pagination.pageSize = pagination.pageSize;
    state.pagination.total = pagination.total;
  }

  state.list = items;
});

export default setDeleteRequests;
